import React, { useState } from 'react'
import { Avatar,Modal, Space } from 'antd';
import NewsDesc from './NewsDesc';
function NewsCheck(props) {
    const [open,setOpen] = useState(false)
    return (
        <>
            <Space> 
                <Avatar
                    src={`/api/assets/images/application/${props.en_image}`} 
                    shape="square"
                    size={160}
                />
                <a  onClick={() => {setOpen(true)}}>{props.text}</a>
            </Space>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <NewsDesc
                    en_id={props.en_id}
                />             
            </Modal>
        </>
    )
}

export default NewsCheck